import { authClientOptions } from '@/pages/api/auth/[...nextauth]';
import { ForgotPasswordScreen } from 'components/screens';
import { GetServerSideProps } from 'next';
import { getServerSession } from 'next-auth';
import authUtils from 'utils/auth';

const ForgotPassword = (): JSX.Element => {
	return <ForgotPasswordScreen />;
};

// If user already has a session
export const getServerSideProps: GetServerSideProps = async (context) => {
	// const session = await getSession(context);
	const session = await getServerSession(
		context.req,
		context.res,
		authClientOptions
	);

	let redirectPath = undefined;
	if (session && session.user && session?.user.user?.role)
		redirectPath = {
			destination: authUtils.getPathToRedirectLoggedUser(
				session?.user.user.role
			),
			permanent: false,
		};

	return {
		props: {},
		redirect: redirectPath,
	};
};

export default ForgotPassword;
